/**
 * @module views\psm\batch\components
 */
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Components extends Vue {}
